
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { EnumLogoutType } from '@xt/client/enums'
import type { ICheckUserInfoResp } from '@xt/client/entities/my-v2/types.d'

@Observer
@Component({
  components: {
    HeaderImage
  }
})
export default class Account extends Vue {
  @Prop() checkUserInfo: ICheckUserInfoResp

  get PageStore() {
    return this.$store.$storeUser
  }

  confirmLogout() {
    this.PageStore.onToggleLogoutModal(EnumLogoutType.NOTICE)
  }

  thinkAgain() {
    this.PageStore.onToggleLogoutVisible(false)
  }
}
